import { useQuery } from 'src/graphql';
import { JOB_SPELL_IGNORES_QUERY } from 'src/graphql/spellCheck/query';

export const useJobSpellIgnores = ({ jobId }) => useQuery(
  JOB_SPELL_IGNORES_QUERY,
  { variables: { jobId } }
);
